import { motion } from "framer-motion";
import { TrendingUp, Zap, Sparkles, Target } from "lucide-react";
import { BUDGET_GUIDE } from "@/data/services";

const ICONS = [Target, Zap, TrendingUp, Sparkles];

export default function BudgetGuide({ onOrder }) {
  return (
    <section
      data-testid="budget-guide-section"
      className="relative py-24 md:py-28 px-6 md:px-10 border-t border-white/5"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="grid md:grid-cols-12 gap-10 mb-14">
          <div className="md:col-span-5">
            <div className="text-[11px] uppercase tracking-[0.4em] text-white/50 mb-4 flex items-center gap-3">
              <span className="dot-gold" />
              Guide budget · Campagnes Ads
            </div>
            <h2 className="font-display text-5xl md:text-6xl tracking-tighter text-white leading-[0.95]">
              Quel budget <br />
              <span className="text-gold-gradient italic">choisir</span> ?
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-white/60 text-base leading-relaxed">
              Nos campagnes publicitaires sont{" "}
              <span className="text-white">100% fiables</span>. Voici notre
              retour d&apos;expérience sur les budgets quotidiens et leurs
              résultats réels — durée conseillée&nbsp;: 1 semaine à 1 mois.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {BUDGET_GUIDE.map((b, i) => {
            const Icon = ICONS[i];
            const isReco = b.recommended;
            return (
              <motion.div
                key={b.price}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                data-testid={`budget-tier-${b.level}`}
                className={`relative rounded-2xl p-6 md:p-7 border ${
                  isReco
                    ? "gold-ring bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a] md:-translate-y-2"
                    : "border-white/10 bg-[#111]"
                }`}
              >
                {isReco && (
                  <span className="absolute -top-3 left-6 bg-[#d4af37] text-black text-[10px] uppercase tracking-[0.3em] px-3 py-1 rounded-full font-semibold">
                    Recommandé
                  </span>
                )}

                <div className="flex items-start justify-between mb-6">
                  <Icon
                    size={22}
                    className={
                      b.tone === "gold"
                        ? "text-[#d4af37]"
                        : b.tone === "silver"
                          ? "text-[#c0c0c0]"
                          : "text-white/40"
                    }
                  />
                  <div className="flex gap-1">
                    {[1, 2, 3, 4].map((n) => (
                      <span
                        key={n}
                        className={`w-1.5 h-1.5 rounded-full ${
                          n <= b.level
                            ? b.tone === "gold"
                              ? "bg-[#d4af37]"
                              : b.tone === "silver"
                                ? "bg-[#c0c0c0]"
                                : "bg-white/40"
                            : "bg-white/10"
                        }`}
                      />
                    ))}
                  </div>
                </div>

                <div className="mb-2">
                  <div
                    className={`font-display text-5xl tracking-tighter ${
                      b.tone === "gold"
                        ? "text-gold-gradient"
                        : b.tone === "silver"
                          ? "text-silver-gradient"
                          : "text-white/70"
                    }`}
                  >
                    {b.price}
                  </div>
                  <div className="text-white/40 text-[10px] uppercase tracking-[0.3em] mt-1">
                    par jour
                  </div>
                </div>

                <div className="mt-6 pt-5 border-t border-white/10">
                  <div className="text-white font-semibold text-sm">
                    {b.label}
                  </div>
                  <div className="text-white/55 text-xs mt-2 leading-relaxed">
                    {b.result}
                  </div>
                </div>

                {isReco && (
                  <button
                    onClick={() => onOrder("Facebook — Campagne Publicitaire (10 $/jour)")}
                    data-testid="budget-reco-cta"
                    className="mt-6 w-full py-3 rounded-full btn-gold text-xs uppercase tracking-wider"
                  >
                    Lancer ma campagne
                  </button>
                )}
              </motion.div>
            );
          })}
        </div>

        <div className="mt-10 text-center text-white/45 text-xs">
          Durée conseillée&nbsp;: 1 semaine à 1 mois · Résultats mesurables ·
          Suivi client inclus
        </div>
      </div>
    </section>
  );
}
